import { Action } from 'redux';
import { Comisionist, ComisionistDetail, Metadata, ComisionistStats } from 'types/api/responses';

export enum ComisionistActions {
  update = 'comisionist/update',
  fetchList = 'comisionist/fetchList',
  fetchDetail = 'comisionist/fetchDetail',
  setFilter = 'comisionist/setFilter',
  createItem = 'comisionist/createItem',
  updateItem = 'comisionist/updateItem',
  deleteItem = 'comisionist/deleteItem',
  uploadDocument = 'comisionist/uploadDocument',
  clearDetail = 'comisionist/clearDetail',
  clearError = 'comisionist/clearError',
  setStats = 'comisionist/setStats',
}

type ComisionistUpdate = {
  isLoading: boolean;
  error?: Error;
} & Action<typeof ComisionistActions.update>;

type ComisionistFetchList = {
  comisionistas: Comisionist[];
  meta: Metadata;
} & Action<typeof ComisionistActions.fetchList>;

type ComisionistFetchDetail = {
  detail: ComisionistDetail;
} & Action<typeof ComisionistActions.fetchDetail>;

type ComisionistSetFilter = {
  filter: {
    account?: string;
    name?: string;
    type?: string;
    primaryStatus?: string;
    secondaryStatus?: string;
    OfficeId?: string;
    updatedAfter?: string;
    branchOfficeId?: string;
  };
} & Action<typeof ComisionistActions.setFilter>;

type ComisionistCreateItem = {
  comisionist: Comisionist;
} & Action<typeof ComisionistActions.createItem>;

type ComisionistUpdateItem = {
  comisionist: Comisionist;
} & Action<typeof ComisionistActions.updateItem>;

type ComisionistDeleteItem = {
  id: string;
} & Action<typeof ComisionistActions.deleteItem>;

type ComisionistUploadDocument = {
  comisionistId: string;
  documentType: string;
  success: boolean;
} & Action<typeof ComisionistActions.uploadDocument>;

type ComisionistClearDetail = Action<typeof ComisionistActions.clearDetail>;

type ComisionistClearError = Action<typeof ComisionistActions.clearError>;

type ComisionistSetStats = {
  stats: ComisionistStats;
} & Action<typeof ComisionistActions.setStats>;

export type ComisionistAction =
  | ComisionistUpdate
  | ComisionistFetchList
  | ComisionistFetchDetail
  | ComisionistSetFilter
  | ComisionistCreateItem
  | ComisionistUpdateItem
  | ComisionistDeleteItem
  | ComisionistUploadDocument
  | ComisionistClearDetail
  | ComisionistClearError
  | ComisionistSetStats;
